<template>
  <ValidationObserver
    ref="inputObserver"
    tag="div" >
    <ValidationProvider
      v-slot="{ errors, failedRules }"
      :name="name"
      :rules="validatorsProcessed">
      <Title
        :action="action"
        :title="title" />
      <b-input
        ref="flowNameInputRef"
        v-model="inputModel"
        autocomplete="off"
        class="sb2-bordered sb2-hoverable sb2-focusable"
        :class="{ empty: !inputModel }"
        :placeholder="placeholder"
        @keydown="catchEnter" />
      <ErrorInfoFooter
        :info="info"
        :errors="errors"
        :failed-rules="failedRules"
        :warning-validators="warningValidators"
        :validator-messages="validatorMessages" />
    </ValidationProvider>
  </ValidationObserver>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIconList from '@/helpers/lists/sb-icon-list';
import Title from '@/components/formElements/Title.form';
import ErrorInfoFooter from '@/components/formElements/ErrorInfoFooter.form';

export default {
  name: 'Input',
  components: {
    Title,
    ErrorInfoFooter,
  },
  props: {
    action: {
      type: Object,
      required: false,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    validators: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'Field',
    },
    info: {
      type: String,
      default: '',
    },
    subtitlePrefixIcon: {
      type: String,
      default: '',
    },
    noSubtitlePrefixIcon: {
      type: Boolean,
      default: false,
    },
    warningValidators: {
      type: Array,
      default: () => [],
    },
    validatorMessages: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      initialValue: '',
      inputModel: '',
      selectedIcon: 0,
      SBColors,
      SBIconList,
    };
  },
  computed: {
    validatorsProcessed() {
      return this.validators ? this.validators.replace('checkDuplicate:', `checkDuplicate:${this.initialValue},`) : '';
    },
  },
  watch: {
    inputModel: {
      handler() {
        this.emitData();
      },
      immediate: false,
    },
    selectedIcon() {
      this.emitData();
    },
    value() {
      this.inputModel = this.value;
    },
  },
  mounted() {
    if (this.value) {
      this.inputModel = this.value;
      this.initialValue = this.value;
    }
    setTimeout(() => {
      this.emitData(true);
      if (this.value) {
        // this.$refs.inputObserver.validate();
      }
    }, 0);

    // if (this.stepID) {
    //   this.$eventBus.$on(`validate-${this.stepID}`, () => {
    //     this.$refs.inputObserver.validate();
    //   });
    // }

    // NOTE: Once we get to the rewrite of the app we should enable setting the text on the input and text fields without taking the focus automatically. Then this timeout wouldn't be needed and we could set the focus element instantly.
    // NOTE: For start extend the loader untill the form is fully loaded and then remove it and set focus where it should be.
    // setTimeout(() => {
    //   if (this.schema.focus) {
    //     this.emitData();
    //     this.$refs.flowNameInputRef.focus();
    //   }
    // }, 3000);
  },
  methods: {
    catchEnter(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        this.$emit('next');
      }
    },
    /** Checks if the validator errors are all of warning type. */
    onlyWarnings() {
      const fields = Object.values(this.$refs.inputObserver.fields).map(field => Object.keys(field.failedRules)).flat(Infinity);
      const someTest = fields.length ? !fields.some(failed => !this.warningValidators.includes(failed)) : false; // if there are no fields, return false because it means the field is validated silently and no failedRules are being recorded
      return someTest;
    },
    validate() {
      this.$refs.inputObserver.validate();
      this.emitData();
    },
    emitData() {
      if (!this.$refs.inputObserver) return;
      this.$refs.inputObserver.validate({ silent: true })
        .then((valid) => {
          this.$emit('status', {
            valid: valid || this.onlyWarnings(),
          });
          this.$emit('input', this.inputModel);
        })
        .finally(() => {
          // if (reset) this.$refs.inputObserver.reset();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
input.form-control {
  height: 34px;
  border-radius: 10px !important;
}

.avatar-select {
  position: absolute;
  top: 1px;
  left: 1px;
  border-radius: 10px 0 0 10px !important;
  z-index: 1;
}

.indent {
  padding-left: 50px !important;
}

.flex-start-image {
  top: 1px;
  position: relative;
}

.subtitle {
  margin-top: 5px;
  font-size: 12px !important;
  font-weight: normal !important;
  text-align: left !important;
  color: #7C8B91 !important;
}
</style>
